import React from "react";
import MuiButton from "@mui/material/Button";
import { ButtonProps } from "@mui/material/Button/Button";

import { CustomButton, useStyles, useStylesDefault } from "./styles";
import { BRAND } from '../../../../api';

interface Props {
  gradient?: boolean;
  target?: string | undefined;
  rel?: string | undefined;
  href?: string | undefined;
  type?: string | undefined;
}

const Button = (props: Props & Omit<ButtonProps, keyof Props>) => {
  const { gradient = false, startIcon, ...other } = props;
  const classes = useStyles();
  const classesDefault = useStylesDefault();

  const modifiedStartIcon = startIcon && BRAND === 'pmaff'
    ? React.cloneElement(startIcon as React.ReactElement, {
        style: {
          color: '#292621',
          ...(startIcon as React.ReactElement).props?.style
        }
      })
    : startIcon;

  return  (
    <>
      {gradient
        //@ts-ignore
        ? <CustomButton className={`${other.className}`} startIcon={modifiedStartIcon} {...other}>
            <span
              className={classes.text}
              {...(
                BRAND === 'pmaff' ||
                BRAND === 'pmvip' ||
                BRAND === 'vph'
                ? {
                style: {
                  color: '#292621'
                }
              } : {})}
            >
              {other.children}
            </span>
          </CustomButton>
        //@ts-ignore
        : <MuiButton className={classesDefault.root} startIcon={modifiedStartIcon} {...other} />
      }
    </>
  );
};

export default Button;
